<template>
	<div>
		<el-dialog title="修改申样信息" :visible.sync="dialogVisible" :close-on-click-modal="false" width="710px" :before-close="handleClose">
			<el-form :model="form" :rules="rules" ref="ruleForm" label-width="82px">
				<el-form-item label="申样备注" label-width="70px">
					<el-input type="textarea" :rows="3" placeholder="请输入申样备注" v-model="form.buyer_remark" maxlength="100" show-word-limit />
				</el-form-item>
				<div class="mb-16">
					<p>
						<span class="yx-color-danger mr-4">*</span>
						<span>申样规格</span>
						<el-button type="text" class="ml-12" @click="syncLatestSpec">同步最新规格</el-button>
					</p>
					<sample-specs
						class="flex-1 mt-10"
						:productId="productId"
						:platformId="platformId"
						@change="getSkuChange"
						:remark="specification_remark"
						ref="sampleSpecs"
						:isShow="true"
						:list="skuList"
					></sample-specs>
				</div>
				<div class="label flex flex-just-between flex-align-center">
					<p>收货地址</p>
					<p @click="autoDiscern" class="auto yx-color-primary pointer">
						<i class="el-icon-edit"></i>
						<span class="ml-6">智能识别地址</span>
					</p>
				</div>
				<el-form-item label="收件人" prop="delivery_name">
					<el-input type="text" placeholder="请输入收件人" v-model="form.delivery_name" maxlength="10" show-word-limit />
				</el-form-item>
				<el-form-item label="手机号" prop="delivery_mobile">
					<el-input type="text" placeholder="请输入手机号" v-model="form.delivery_mobile" maxlength="11" />
				</el-form-item>
				<el-form-item label="所在区域" prop="province">
					<el-cascader class="width100" v-if="dialogVisible" @change="selecteFun" :options="AreaTree" clearable v-model="selectedOptions">
					</el-cascader>
				</el-form-item>
				<el-form-item label="详细地址" prop="delivery_addr">
					<el-input type="textarea" :rows="3" placeholder="请输入详细地址" v-model="form.delivery_addr" maxlength="60" show-word-limit />
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
		<auto-address @returnValue="returnValue" ref="autoAddress"></auto-address>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import area from '@/utils/area/index';
import autoAddress from '@/views/common/autoAddress';
import { updateSample } from '@/api/cooperationProgress';
import sampleSpecs from '@/components/business/sampleSpecs';
import { updateProductSpec } from '@/api/sampleOrder';
import debounce from 'lodash/debounce';
export default {
	name: 'updateSampleDialog',
	props: {
		productId: {
			type: String,
			default: '',
		},
		platformId: {
			type: String,
			default: dataMap.PLATFORM_DY.value,
		},
		thirdProductId: {
			type: String,
			default: '',
		},
	},
	components: {
		autoAddress,
		sampleSpecs,
	},
	data() {
		return {
			dialogVisible: false,
			selectedOptions: [],
			AreaTree: area.AreaTree,
			CodeToText: area.CodeToText,
			TextToCode: area.TextToCode,
			form: {
				cooperate_id: '',
				sample_sn: '',
				buyer_remark: '',
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				area: '',
				code: '',
				delivery_addr: '',
				skus: [],
			},
			rules: {
				delivery_name: { required: true, message: '请输入收件人', trigger: 'blur' },
				delivery_mobile: { required: true, message: '请输入手机号', trigger: 'blur' },
				province: { required: true, message: '请选择所在区域', trigger: 'change' },
				delivery_addr: { required: true, message: '请输入详细地址', trigger: 'blur' },
			},
			skuList: [],
			applySku: [],
			specification_remark: '',
			sample_sn: '',
		};
	},
	methods: {
		show(row) {
			row = { ...row };
			this.specification_remark = row.specification_remark;
			this.sample_sn = row.sample_sn;
			Object.keys(this.form).forEach(key => (this.form[key] = row[key]));
			let [province, city] = this.TextToCode([row.province, row.city, row.area]);
			this.selectedOptions = [province, city, row.code];
			this.form.code = this.selectedOptions[2];
			//商品是否有sku
			if (this.form.skus && this.form.skus.length) {
				let list = this.form.skus.filter(item => Number(item.nums));
				//商品有sku，用户是否未选择sku
				if (list.length) {
					this.skuList = list.map(item => {
						return {
							...item,
							hasSku: true,
							num: item.nums,
							id: item.outer_sku_id,
							skuId: item.outer_sku_id,
						};
					});
				} else {
					this.skuList = [{ hasSku: true, price: '', num: '' }];
				}
			} else {
				this.skuList = [{ hasSku: false, ramerk: '' }];
			}
			this.dialogVisible = true;
		},
		handleClose() {
			this.form = {
				cooperate_id: '',
				sample_sn: '',
				buyer_remark: '',
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				area: '',
				code: '',
				delivery_addr: '',
				skus: [],
			};
			this.specification_remark = '';
			this.skuList = [];
			this.applySku = [];
			this.$refs?.sampleSpecs?.reset();
			this.selectedOptions = [];
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		selecteFun(e) {
			const code = e[2];
			const [province, city, area] = this.CodeToText(this.selectedOptions);
			this.form.province = province;
			this.form.city = city;
			this.form.area = area;
			this.form.code = code;
		},
		autoDiscern() {
			this.$refs.autoAddress.show();
		},
		returnValue(e) {
			for (let key in e) {
				this.form[key] = e[key];
			}
			let [province, city, area] = this.TextToCode([e.province, e.city, e.area]);
			if (!area) {
				this.form['delivery_addr'] = e.province + e.city + e.area + e.delivery_addr;
				this.$set(this.rules, 'province', { required: false, message: '请选择区域', trigger: 'change' });
			} else {
				this.$set(this.rules, 'province', { required: true, message: '请选择区域', trigger: 'change' });
			}
			this.selectedOptions = [province, city, e.code];
			this.form.code = this.selectedOptions[2];
		},
		getSkuChange(val, specification_remark) {
			this.applySku = val.map(item => {
				return {
					outer_sku_id: item.skuId,
					nums: item.num,
				};
			});
			this.specification_remark = specification_remark;
		},
		submit: throttle(function () {
			const { ...resets } = this.form;
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { code } = await updateSample({ ...resets, skus: this.applySku, specification_remark: this.specification_remark });
				if (code !== 0) return;
				this.$message.success('修改申样信息成功');
				this.$emit('getList');
				this.handleClose();
			});
		}, 1000),
		syncLatestSpec: debounce(async function () {
			const params = { thirdProductId: this.thirdProductId, sampleSn: this.sample_sn, platformId: this.platformId };
			try {
				const { code } = await updateProductSpec(params);
				if (code === 0) {
					this.$message.success('同步最新规格成功，请选择规格添加');
					await this.$emit('getList', true);
				}
			} catch (error) {
				this.$message.error('同步最新规格失败');
			}
		}),
	},
};
</script>

<style lang="less" scoped>
.label {
	font-size: 14px;
	color: #333;
	font-weight: 700;
	margin-bottom: 16px;
}
.auto {
	font-weight: normal;
}
</style>
